import x from "i18next";
import u from "immutability-helper";
const I = "unsorted", p = (t, r) => {
  for (let e = 0; e < t.length; e++) {
    const a = t[e].tattrs.findIndex((n) => r === n.id);
    if (a !== -1)
      return { folderIndex: e, tattrIndex: a };
  }
  return null;
}, l = (t, r, e) => {
  var i;
  const a = t.findIndex(({ id: d }) => d === r), n = (i = t[a]) == null ? void 0 : i.variants.findIndex((d) => d.id === e);
  return n !== -1 ? { articleIndex: a, variantIndex: n } : null;
}, h = {
  addVariableToFolder: (t, r, e) => {
    const { t: a } = x, n = t.findIndex(({ id: i }) => String(i) === String(e == null ? void 0 : e.id));
    if (e && n >= 0)
      return u(t, {
        [n]: {
          tattrs: {
            $unshift: [r]
          }
        }
      });
    if (e != null && e.id && (e != null && e.name))
      return u(t, {
        $unshift: [{
          id: String(e.id),
          name: e.name,
          tattrs: [r]
        }]
      });
    {
      const i = e && t.findIndex(({ id: d }) => d === I);
      return (i || i === 0) && i !== -1 ? u(t, {
        [i]: {
          tattrs: {
            $unshift: [r]
          }
        }
      }) : u(t, {
        $unshift: [{
          id: I,
          name: a("unallocated"),
          tattrs: [r]
        }]
      });
    }
  },
  removeVariableFromFolders: (t, r) => {
    const e = p(t, r);
    return e ? u(t, {
      [e.folderIndex]: {
        tattrs: {
          $splice: [[e.tattrIndex, 1]]
        }
      }
    }) : t;
  },
  updateVariableInFolders: (t, r) => {
    const e = p(t, r.id);
    return e ? u(t, {
      [e.folderIndex]: {
        tattrs: {
          $splice: [[e.tattrIndex, 1, r]]
        }
      }
    }) : t;
  }
}, $ = {
  addVariableToVariation: (t, r, e, a) => {
    const n = l(t, r, e);
    return !n || t[n.articleIndex].variants[n.variantIndex].tattrs.findIndex((d) => d === a.id || d === `${a.id}.${a.sideId}`) !== -1 ? t : u(t, {
      [n.articleIndex]: {
        variants: {
          [n.variantIndex]: {
            tattrs: { $push: [`${a.id}.${a.sideId}`] }
          }
        }
      }
    });
  },
  removeVariableFromVariation: (t, r, e, a) => {
    const n = l(t, r, e);
    if (!n)
      return t;
    const d = t[n.articleIndex].variants[n.variantIndex].tattrs.findIndex((s) => s === a.id || s === `${a.id}.${a.sideId}`);
    return d === -1 ? t : u(t, {
      [n.articleIndex]: {
        variants: {
          [n.variantIndex]: {
            tattrs: { $splice: [[d, 1]] }
          }
        }
      }
    });
  },
  addTableToVariation: (t, r, e, a) => {
    const n = l(t, r, e);
    return !n || t[n.articleIndex].variants[n.variantIndex].tables.includes(a) ? t : u(t, {
      [n.articleIndex]: {
        variants: {
          [n.variantIndex]: {
            tables: { $push: [a] }
          }
        }
      }
    });
  },
  removeTableFromVariation: (t, r, e, a) => {
    var d;
    const n = l(t, r, e);
    if (!n)
      return t;
    const i = (d = t[n.articleIndex].variants[n.variantIndex].tables) == null ? void 0 : d.findIndex((s) => s === a);
    return i === -1 ? t : u(t, {
      [n.articleIndex]: {
        variants: {
          [n.variantIndex]: {
            tables: { $splice: [[i, 1]] }
          }
        }
      }
    });
  },
  addVariationToVariation: (t, r, e, a) => {
    const n = t.findIndex(({ id: i }) => i === a);
    return n === -1 || t[n].parents.includes(e) ? t : u(t, {
      [n]: {
        parents: { $push: [e] }
      }
    });
  },
  removeVariationFromVariation: (t, r, e, a) => {
    var d;
    const n = t.findIndex(({ id: s }) => s === a), i = (d = t[n]) == null ? void 0 : d.parents.findIndex((s) => s === e);
    return i === -1 ? t : u(t, {
      [n]: {
        parents: { $splice: [[i, 1]] }
      }
    });
  }
}, f = {
  setUnusedParams: (t, r) => {
    let e = !1;
    return {
      sides: t.map((a) => ({
        ...a,
        tables: a.tables.filter((n) => r.match(new RegExp(`id="${n.id}"`, "g"))),
        tattrFolders: a.tattrFolders.map(({ id: n, name: i, tattrs: d }) => ({
          id: n,
          name: i,
          tattrs: d.map((s) => r.match(new RegExp(`id="${s.id}"[^>]*data-side-id="${a.id}"`, "g")) ? { ...s, notUsed: !1 } : (e = !0, { ...s, notUsed: !0 }))
        })),
        carticles: a.carticles.reduce((n, i) => {
          var d;
          return r.match(new RegExp(`id="${i.id}"[^>]*data-sideid="${a.id}"`, "g")) ? [
            ...n,
            { ...i, parents: (d = i.parents) == null ? void 0 : d.filter((s) => r.match(new RegExp(`id="${s}"`, "g"))) }
          ] : n;
        }, [])
      })),
      hasUnused: e
    };
  },
  clean: (t) => t.map((r) => ({
    ...r,
    tattrFolders: r.tattrFolders.map(({ id: e, name: a, tattrs: n }) => ({
      id: e,
      name: a,
      tattrs: n.reduce((i, d) => d.notUsed ? i : [...i, d], [])
    }))
  }))
}, v = (t) => {
  const r = [], e = document.querySelectorAll("span.variable");
  if (e.length)
    for (const a of e) {
      const n = t.find(({ id: d }) => d === a.dataset.sideId);
      if (!n) {
        r.push(a);
        continue;
      }
      !!n.tattrFolders.find(({ tattrs: d }) => d.find(({ id: s }) => s === a.id)) || r.push(a);
    }
  return r;
}, o = [
  ["#D5EDD5", "#79BE70"],
  ["#CCE2F2", "#71BDF4"],
  ["#EEEDC9", "#E8E578"],
  ["#F1E5FD", "#DAB5FF"],
  ["#F5DADA", "#F7ADAD"]
], g = (t) => {
  if (!t)
    return;
  const r = t.reduce((a, n, i) => a + `
      .side-name-${n.id}::before { background: ${o[i % o.length][1]} }

      span.variable[data-side-id="${n.id}"] {
        --primary-color: ${o[i % o.length][1]};
        --secondary-color: ${o[i % o.length][0]};
      }

      section.variations[data-sideid="${n.id}"] {
        --primary-color: ${o[i % o.length][1]};
        --secondary-color: ${o[i % o.length][0]};
      }

      section.products-table[data-sideid="${n.id}"] {
        --primary-color: ${o[i % o.length][1]};
        --secondary-color: ${o[i % o.length][0]};
      }
    `, ""), e = document.getElementById("editor_variable_colors");
  if (e)
    e.innerHTML = r;
  else {
    const a = document.head || document.getElementsByTagName("head")[0], n = document.createElement("style");
    n.id = "editor_variable_colors", a.appendChild(n), n.innerHTML = r;
  }
};
export {
  I as UNSORTED_ID,
  g as appendSidesColors,
  v as getRemovedVariables,
  h as sideVariableHelpers,
  $ as sideVariationHelpers,
  f as sidesUpdateFunctions
};
